export default __webpack_public_path__ + "static/media/location.ebc05d50.png";